import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS, tooltip } from '@databases/keyboard-shortcuts';
import React from 'react';

import { clearValues } from '../actions/clear-values';
import { SELECT_VALUE_MENU_ACTIONS, type MenuItemBuilder } from '../types';
import { ElementAfterShortCutWrapper, ElementBeforeIconWrapper } from '../ui/components';

export const clearValuesMenuItem: MenuItemBuilder = ({
  capabilities: { canClearContent },
  contentId,
  formatMessage,
  selectionsActions,
  selectedValuesCount,
}) => ({
  isEnabled: () => canClearContent,
  menuItem: {
    key: SELECT_VALUE_MENU_ACTIONS.CLEAR_VALUES,
    content: formatMessage(messages['value-actions.clear-cells'], {
      valuesCount: selectedValuesCount.toString(),
    }),
    onClick: () => clearValues(contentId),
    onMouseEnter: () => {
      selectionsActions.clearSelectionIntent();
    },
    closeOnClick: true,
    elemAfter: <ElementAfterShortCutWrapper tooltip={tooltip(SHORTCUTS.CLEAR.keyMap)} />,
    elemBefore: (
      <ElementBeforeIconWrapper>
        <CrossCircleIcon label="" spacing="spacious" />
      </ElementBeforeIconWrapper>
    ),
  },
});
